// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .radial-gauge-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .radial-gauge-widget-tool-tip{
        visibility: hidden;
        opacity: 0;
        position: absolute;
        padding: 8px 12px;
        border-radius: 4px;
        box-sizing: border-box;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 0.884);
        transition: opacity 2s ease, visibility 0s linear 2s;
    }
    .radial-gauge-widget-container:hover .radial-gauge-widget-tool-tip{
        visibility: visible;
        opacity: 1;
        transition: opacity 2s ease;
    }
    .radial-gauge-widget-tool-tip p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0px;
        font-size: 13px;
        color: rgb(110, 110, 110);
    }
    .radial-gauge-widget-tool-tip span{
        margin-left: 15px;
        color: rgb(20, 20, 20);
    }
    .radial-gauge-widget-header{
        width: 100%;
        padding: 16px 20px;
        box-sizing: border-box;
    }
    .radial-gauge-widget-header p{
        margin: 0px;
    }
}
@media screen and (max-width:949px){
    .radial-gauge-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .radial-gauge-widget-tool-tip{
        visibility: hidden;
        opacity: 0;
        position: absolute;
        padding: 8px 12px;
        border-radius: 4px;
        box-sizing: border-box;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 0.884);
        transition: opacity 3s ease, visibility 0s linear 4s;
    }
    .radial-gauge-widget-container:hover .radial-gauge-widget-tool-tip{
        visibility: visible;
        opacity: 1;
        transition: opacity 3s ease;
    }
    .radial-gauge-widget-tool-tip p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0px;
        font-size: 13px;
        color: rgb(110, 110, 110);
    }
    .radial-gauge-widget-tool-tip span{
        margin-left: 15px;
        color: rgb(20, 20, 20);
    }
    .radial-gauge-widget-header{
        width: 100%;
        padding: 16px 20px;
        box-sizing: border-box;
    }
    .radial-gauge-widget-header p{
        margin: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/AnalogueGauges/RadialGaugeWidget.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,2CAA2C;QAC3C,4CAA4C;QAC5C,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,2CAA2C;QAC3C,4CAA4C;QAC5C,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .radial-gauge-widget-container{\n        position: relative;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        box-sizing: border-box;\n    }\n    .radial-gauge-widget-tool-tip{\n        visibility: hidden;\n        opacity: 0;\n        position: absolute;\n        padding: 8px 12px;\n        border-radius: 4px;\n        box-sizing: border-box;\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);\n        background-color: rgba(255, 255, 255, 0.884);\n        transition: opacity 2s ease, visibility 0s linear 2s;\n    }\n    .radial-gauge-widget-container:hover .radial-gauge-widget-tool-tip{\n        visibility: visible;\n        opacity: 1;\n        transition: opacity 2s ease;\n    }\n    .radial-gauge-widget-tool-tip p{\n        display: flex;\n        justify-content: space-between;\n        margin: 5px 0px;\n        font-size: 13px;\n        color: rgb(110, 110, 110);\n    }\n    .radial-gauge-widget-tool-tip span{\n        margin-left: 15px;\n        color: rgb(20, 20, 20);\n    }\n    .radial-gauge-widget-header{\n        width: 100%;\n        padding: 16px 20px;\n        box-sizing: border-box;\n    }\n    .radial-gauge-widget-header p{\n        margin: 0px;\n    }\n}\n@media screen and (max-width:949px){\n    .radial-gauge-widget-container{\n        position: relative;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        box-sizing: border-box;\n    }\n    .radial-gauge-widget-tool-tip{\n        visibility: hidden;\n        opacity: 0;\n        position: absolute;\n        padding: 8px 12px;\n        border-radius: 4px;\n        box-sizing: border-box;\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);\n        background-color: rgba(255, 255, 255, 0.884);\n        transition: opacity 3s ease, visibility 0s linear 4s;\n    }\n    .radial-gauge-widget-container:hover .radial-gauge-widget-tool-tip{\n        visibility: visible;\n        opacity: 1;\n        transition: opacity 3s ease;\n    }\n    .radial-gauge-widget-tool-tip p{\n        display: flex;\n        justify-content: space-between;\n        margin: 5px 0px;\n        font-size: 13px;\n        color: rgb(110, 110, 110);\n    }\n    .radial-gauge-widget-tool-tip span{\n        margin-left: 15px;\n        color: rgb(20, 20, 20);\n    }\n    .radial-gauge-widget-header{\n        width: 100%;\n        padding: 16px 20px;\n        box-sizing: border-box;\n    }\n    .radial-gauge-widget-header p{\n        margin: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
